module.exports = __webpack_public_path__ + "static/media/8.a52d7226.jpg";